// @ constants
const actionTypes = require('constants/actionTypes');
import { SEND_KEYS_SIGNATURE_EVENT_TAG, SEND_KEYS_SIGNATURE_CATEGORY_ERROR } from 'constants/tagging'

// @actions
const signaturePatternActions = require('actions/signaturePattern');

// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

const fetchSignatureKeyStatusError = () => ({
    type: actionTypes.FETCH_SIGNATURE_KEY_STATUS_ERROR
});

const fetchSignatureKeyStatusRequest = () => ({
    type: actionTypes.FETCH_SIGNATURE_KEY_STATUS_REQUEST,
});

const fetchSignatureKeyStatusSuccess = response => ({
    type: actionTypes.FETCH_SIGNATURE_KEY_STATUS_SUCCESS,
    payload: {
        response
    }
});

const validateSignatureKeyStatus = callback => dispatch => {
    return APIGet({
        dispatch,
        endpoint: 'getSendSignatureKey'
    })
    .then((response) => {
        if (response.verified) {
            callback(response.verified);
        } else {
            dispatch(fetchSignatureKeyStatusSuccess(response));
        }
    })
    .catch(() => {
        dispatch(fetchSignatureKeyStatusError());
    });
}

const fetchSignatureKeyStatus = () => (dispatch) => {
    dispatch(fetchSignatureKeyStatusRequest());

    return APIGet({
        dispatch,
        endpoint: 'getSendSignatureKey'
    })
    .then((response) => {
        dispatch(fetchSignatureKeyStatusSuccess(response));
    })
    .catch(() => {
        dispatch(fetchSignatureKeyStatusError());
    });
}

const sendSignatureKeyClick = () => ({
    type: actionTypes.SEND_SIGNATURE_KEY
});

const postSignatureKeyStatusRequest = () => ({
    type: actionTypes.POST_SIGNATURE_KEY_STATUS_REQUEST
});

const postSignatureKeyStatusError = () => ({
    type: actionTypes.POST_SIGNATURE_KEY_STATUS_ERROR
});

const postSignatureKeyStatusSuccess = () => ({
    type: actionTypes.POST_SIGNATURE_KEY_STATUS_SUCCESS
});

const postSignatureKeyStatus = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(postSignatureKeyStatusRequest());
        const requestData = {
            query: {
                dataToken
            },
        };
        return APIPost({
            dispatch,
            endpoint : 'requestSendSignatureKey',
            params: requestData
        })
        .then(() => {
            dispatch(postSignatureKeyStatusSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(postSignatureKeyStatusError());
            } else {
                throw response;
            }
        });
    }

    return new Promise(() => {
        const tagging = { customEventTag: SEND_KEYS_SIGNATURE_EVENT_TAG, customCategoryError: SEND_KEYS_SIGNATURE_CATEGORY_ERROR }
        signaturePatternActions.validateAndExecute(dispatch, getState, callback, false, tagging);
    });
}

module.exports = {
    fetchSignatureKeyStatus,
    postSignatureKeyStatus,
    sendSignatureKeyClick,
    validateSignatureKeyStatus
};
